var path = 'app/portainer/components/code-editor/codeEditor.html';
var html = "<textarea id=\"{{ $ctrl.identifier }}\" class=\"form-control\" placeholder=\"{{ $ctrl.placeholder }}\"></textarea>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;